import React, { useEffect, useState, useRef } from "react";

import { useSelector, useDispatch } from "react-redux";
import {
  updateProduct,
  priceCalculator,
  selectProducts,
} from "./productsSlice";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IconButton from "@material-ui/core/IconButton";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  outer: { display: "flex", flexFlow: "column" },
  addIcon: {
    // marginRight: 8,
    // color: '#fff',
  },
  title: {
    color: "#fff",
    padding: 16,
    backgroundColor: " #42494E",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
  },
  textItem: {
    marginBottom: 16,
  },
  productButton: {
    width: "100%",
  },
}));

export default function Calculator(props) {
  const { edit, product, handlePriceCalculation, productPage } = props;
  // console.log('in the calc', edit, product)
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const [marginChanged, setMarginChanged] = useState(false);
  const [open, setOpen] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [rrp, setRRP] = useState(edit ? product.rrp / 100 : "");
  const [sellingPrice, setSellingPrice] = useState(
    edit ? product.sellingPrice / 100 : ""
  );
  const [freight, setFreight] = useState(edit ? product.freight / 100 : "");
  const [costPrice, setCostPrice] = useState(
    edit ? product.costPrice / 100 : ""
  );
  const [margin, setMargin] = useState(edit ? product.margin * 100 : "");
  const [valuesToUpdate, setValuesToUpdate] = useState({});
  const { priceCalculation } = useSelector(selectProducts);
  useEffect(() => {
    setSellingPrice(priceCalculation.sellingPrice);
    setMargin(
      priceCalculation.margin
        ? (priceCalculation.margin * 100).toFixed(4).toString()
        : priceCalculation.margin === 0
        ? " 0"
        : ""
    );
    setSubmitDisabled(false);
    setMarginChanged(false);
  }, [priceCalculation]);

  useEffect(() => {
    // if (costPrice !== '' && freight !== '' && rrp !== '') {
    //   console.log('margined');
    //   const marginPriceTimeout = setTimeout(() => {
    //     handleCaluclate(true);
    //   }, 1000);
    //   return () => clearTimeout(marginPriceTimeout);
    // }
  }, [dispatch, margin]);

  const handleClickOpen = () => {
    setSubmitDisabled(true);

    setRRP(product.rrp / 100);
    setSellingPrice(product.sellingPrice / 100);
    setFreight(product.freight / 100);
    setCostPrice(product.costPrice / 100);
    setMargin(product.margin * 100);

    setOpen(true);
  };

  const handleClose = () => {
    setRRP("");
    setSellingPrice("");
    setFreight("");
    setCostPrice("");
    setMargin("");
    setSubmitDisabled(false);
    setMarginChanged(false);
    setValuesToUpdate({});
    setOpen(false);
  };

  const handleCaluclate = () => {
    let values = {
      cp: Math.round(Number(costPrice) * 100),
      f: Math.round(Number(freight) * 100),
      rrp: Math.round(Number(rrp) * 100),
    };
    if (marginChanged && margin < 100) {
      // values.m = Number(margin) / 100;
      values.m = Number(margin) === -0 ? -1 : Number(margin) / 100;
    } else if (Number(margin) === -0) {
      values.m = -1;
    } else {
      values.m = 0.3;
    }

    setValuesToUpdate(values);
    dispatch(
      priceCalculator({
        values: values,
        token: jwtToken,
      })
    );
  };

  const handleChange = (e, type) => {
    switch (type) {
      case "rrp":
        setRRP(e.target.value);
        break;
      case "f":
        setFreight(e.target.value);
        break;

      case "cp":
        setCostPrice(e.target.value);
        break;

      case "m":
        setMargin(e.target.value);
        setMarginChanged(true);
        break;
    }
    setSubmitDisabled(true);
  };

  function renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map((key) => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  const handleUpdate = () => {
    let updatedValues = renameKeys(valuesToUpdate, {
      cp: "costPrice",
      f: "freight",
      rrp: "rrp",
      m: "margin",
      sp: "sellingPrice"
    });
    
    if (productPage && !edit) {
      handlePriceCalculation(updatedValues);
      handleClose();
    } else if (Number(margin) <= 100) {
      dispatch(
        updateProduct({
          token: jwtToken,
          product: updatedValues,
          id: product.id,
          catIDs: [],
          removedCats: [],
          images: [],
          excludedClients: [],
          includedClients: [],
          imageChange: {
            imagesAdded: [],
            imagesRemoved: [],
            imagesUpdated: [],
          },
        })
      );
    }
  };

  const classes = useStyles();

  return (
    <div>
      {productPage ? (
        <Button
          className={classes.productButton}
          variant="contained"
          color="primary"
          component="span"
          onClick={handleClickOpen}
        >
          Price Calculation
        </Button>
      ) : (
        <Tooltip title="Price Calculator">
          <IconButton aria-label="price calculator" style={{ color: "#fff" }}>
            <LocalAtmIcon
              className={classes.addIcon}
              onClick={handleClickOpen}
            />
          </IconButton>
        </Tooltip>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle
          disableTypography
          className={classes.title}
          id="form-dialog-title"
        >
          Price Calculator
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            style={{ paddingTop: 16, textAlign: "center", marginBottom: 32 }}
          >
            {edit
              ? "Update RRP, Freight and Cost Price to calculate Margin and Selling Price. Update margin to manually overide"
              : "Enter RRP, Freight and Cost Price to calculate Margin and Selling Price. Update Margin to manually overide"}
            .{" "}
            {productPage &&
              !edit &&
              `\Original calculation values will be added to your product page to avoid rounding issues. Selling price will not be shown.`}{" "}
          </DialogContentText>

          <Grid item sm>
            <Grid
              container
              spacing={1}
              direction="row"
              justifyContent="center"
              alignItems="center"
              wrap="wrap"
            >
              {/* <Grid
                  className={classes.prodInfoGrid}
                  container
                  spacing={3}
                  direction="row"
                  justifyContent="space between"
                > */}
              <Grid item sm className={classes.detailsItem} margin="dense">
                <TextField
                  className={classes.informationTexts}
                  key={product.rrp}
                  defaultValue={
                    edit ? (product.rrp / 100).toFixed(2).toString() : ""
                  }
                  variant="outlined"
                  required
                  margin="dense"
                  id="rrp"
                  label="($) RRP"
                  name="rrp"
                  autoComplete="text"
                  onChange={(e) => handleChange(e, "rrp")}
                />
              </Grid>

              <Grid item sm className={classes.detailsItem} margin="dense">
                <TextField
                  className={classes.informationTexts}
                  key={product.freight}
                  defaultValue={
                    edit ? (product.freight / 100).toFixed(2).toString() : ""
                  }
                  variant="outlined"
                  required
                  margin="dense"
                  id="freight"
                  label="($) Freight"
                  name="freight"
                  autoComplete="text"
                  onChange={(e) => handleChange(e, "f")}
                />
              </Grid>
              {/* </Grid> */}
              {/* <Grid
                  container
                  spacing={3}
                  direction="row"
                  justifyContent="space between"
                  className={classes.prodInfoGrid}
                > */}
              <Grid item sm className={classes.detailsItem} margin="dense">
                <TextField
                  className={classes.informationTexts}
                  key={product.costPrice}
                  defaultValue={
                    edit ? (product.costPrice / 100).toFixed(2).toString() : ""
                  }
                  variant="outlined"
                  required
                  margin="dense"
                  id="cost-price"
                  label="($) Cost Price"
                  name="cost-price"
                  autoComplete="name"
                  onChange={(e) => handleChange(e, "cp")}
                />
              </Grid>

              <Grid item sm className={classes.detailsItem} margin="dense">
                <TextField
                  className={classes.informationTexts}
                  // key={product.margin}
                  // defaultValue={
                  //   edit ? `${(product.margin * 100).toFixed(2)}` : ''
                  // }
                  key={`${sellingPrice + "-margin"}`}
                  defaultValue={
                    margin
                      ? edit
                        ? Number(margin).toFixed(2).toString()
                        : margin
                      : ""
                  }
                  variant="outlined"
                  // disabled
                  margin="dense"
                  id="margin"
                  label="Margin (%)"
                  name="margin"
                  onChange={(e) => handleChange(e, "m")}
                  error={margin >= 100}
                  helperText={
                    margin >= 100 ? "Margin cannot be greater than 100%" : ""
                  }
                />
              </Grid>
              <Grid item sm className={classes.detailsItem} margin="dense">
                <TextField
                  className={classes.informationTexts}
                  key={sellingPrice}
                  defaultValue={
                    sellingPrice ? sellingPrice.toFixed(2).toString() : ""
                  }
                  // value={sellingPrice}
                  // value={
                  //   priceCalculation.sellingPrice
                  //     ? Number(priceCalculation.sellingPrice)
                  //         .toFixed(2)
                  //         .toString()
                  //     : ''
                  // }
                  // value={
                  //   edit
                  //     ? (product.sellingPrice / 100).toFixed(2).toString()
                  //     : priceCalculator.sellingPrice
                  // }
                  disabled
                  variant="outlined"
                  margin="dense"
                  id="points-price"
                  label="($) Selling Price"
                  name="points-price"
                  autoComplete="name"
                  // onChange={(e) => setPointsShopPrice(e.target.value)}
                />
              </Grid>
              {/* </Grid> */}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 24 }}>
          <Grid container spacing={2} direction="row">
            <Grid item sm>
              <ColorButton onClick={handleClose} color="primary">
                Cancel
              </ColorButton>
            </Grid>
            <Grid item sm>
              <ColorButton
                onClick={handleCaluclate}
                color="secondary"
                disabled={freight === "" || rrp === "" || costPrice === ""}
              >
                Calculate Price
              </ColorButton>
            </Grid>
            {(edit || productPage) && (
              <Grid item sm>
                <ColorButton
                  disabled={submitDisabled}
                  onClick={handleUpdate}
                  color="secondary"
                >
                  Update Product
                </ColorButton>
              </Grid>
            )}
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}
